module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/file-aee0ce908be733cfee5a5a793f506ee3.svg";